function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-check-circle",
  d: "M40 20A20 20 0 1120 0a20 20 0 0120 20zM17.686 30.589l14.839-14.838a1.29 1.29 0 000-1.825L30.7 12.101a1.29 1.29 0 00-1.825 0l-12.1 12.1-5.65-5.65a1.29 1.29 0 00-1.825 0l-1.826 1.826a1.29 1.29 0 000 1.825l8.387 8.387a1.29 1.29 0 001.825 0z",
  fill: "#002f4d"
});
var SvgBasicCheckIcon = function SvgBasicCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref);
};
export default SvgBasicCheckIcon;